export default __webpack_public_path__ + "static/media/PG.96a0f9ce.svg";